import PropTypes from "prop-types";
import React from "react";
import Listing from "./components/Listing";
import { withRouter } from "react-router-dom";
import { acceptCookyPolicy } from "app/pages/.shared/CookiePolicyFooter/cookiePolicyActionCreators";
import { clearProduct, fetchProducts } from "app/pages/Listing/productActionCreators";
import { getPrefetchedPhotos } from "app/pages/Listing/productsSelector";
import { productShape } from "app/utils/propTypes";
import Loader from "app/pages/.shared/Loader";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { sendTagOnListingLoad, sendTagOnNavlogSeenProducts } from "app/utils/analytics";
import {
	resetAllProductsFilter,
	setProductsFilter,
	setProductsFilters,
} from "app/pages/Listing/ProductFilters/productsFilterActionCreators";
import { NAVLOGS_SHOW_SLIDES_NUMBER, PRODUCTS_FILTERS_KEY } from "app/constants";
import isEqual from "lodash/isEqual";
import get from "lodash/get";
import RequireSignupFirst from "app/pages/Auth/RequireSignupFirst";
import { parseQueries } from "app/utils/routerUtils";
import { fetchNavLogs } from "app/pages/Listing/NavLogs/navLogActionCreators";
import { shouldFetchNavlogs } from "app/pages/Listing/NavLogs/navLogsSelector";
import { getPartnerCode, getPartnerMarketing } from "app/reducers/partnerSelector";
import { getCurrentShop } from "app/reducers/shopSelector";

class ListingContainer extends React.Component {
	constructor() {
		super();
		this.state = {
			loading: true,
		};
		this.applyProductFiltersFromQueries = this.applyProductFiltersFromQueries.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		const { history, match, productsFilterMetaData } = nextProps;

		const query = parseQueries(history.location.search);
		const filterQuery = JSON.parse(query.filterBy || "{}");

		if (
			!isEqual(this.props.history.location.search, history.location.search) ||
			!isEqual(match.url, this.props.match.url) ||
			!isEqual(productsFilterMetaData, this.props.productsFilterMetaData)
		) {
			// on met à jour les filtres au changement d'URL
			// notamment pour les deeplink dans les menus qui ne passent pas par le SSR
			this.applyProductFiltersFromQueries(filterQuery);
		}
	}

	componentDidUpdate(prevProps) {
		if (prevProps.authToken !== this.props.authToken && this.props.shouldFetchNavlogs) {
			this.props.fetchNavLogs().then(res => {
				const navlogs = get(res, "data", []); // navlogs can be equal to {} if no navlogs is returned by the endpoint
				if (navlogs && navlogs.length > 0) {
					sendTagOnNavlogSeenProducts(
						navlogs
							.slice(0, NAVLOGS_SHOW_SLIDES_NUMBER[this.props.resolution])
							.map(navlog => ({
								...navlog,
								lastSeenProductType: navlog.quotationURL ? "quote" : "product",
							}))
					);
				}
			});
		}
	}

	componentDidMount() {
		const { fetchProducts, history, productsVisibility, shop, partnerCode } = this.props;
		const query = parseQueries(history.location.search);

		const filterQuery = JSON.parse(query.filterBy || "{}");
		this.applyProductFiltersFromQueries(filterQuery);

		fetchProducts({ productsVisibility, shop, partnerCode }).then(res => {
			this.setState({
				loading: false,
			});

			const products = get(res, "data.products", []);
			sendTagOnListingLoad(products.slice(0, 3));
		});

		// pour ne pas avoir des données de la dernière fiche produit consultée s'afficher brièvement
		// à l'ouverture d'une fiche produit dans un onglet
		this.props.clearProduct();
	}

	componentWillUnmount() {
		// Sur mobile, pas de new tab donc on clean avant de passer à la fiche produit
		this.props.clearProduct();

		// Pour que le menu n'affiche pas de filtre sélectionné
		// lorsque nous nous rendons sur une fiche produit
		this.props.resetAllProductsFilter();
		this.props.acceptCookyPolicy();
	}

	applyProductFiltersFromQueries(query) {
		this.props.setProductsFilters(
			Object.keys(PRODUCTS_FILTERS_KEY)
				.filter(key => query[PRODUCTS_FILTERS_KEY[key]])
				.map(key => {
					return {
						key: PRODUCTS_FILTERS_KEY[key],
						value: query[PRODUCTS_FILTERS_KEY[key]],
					};
				})
		);
	}

	render() {
		const query = parseQueries(this.props.location.search);
		return (
			<RequireSignupFirst
				{...this.props}
				renderComponent={props => {
					return (
						<div>
							<Listing
								idSpotlight={query.spotlight}
								{...props}
								/**
								 * on affiche le nombre de produits que
								 * lorsque la requête côté front est finie
								 */
								displayProductsCount={this.state.loading === false}
							/>
							{this.state.loading && (
								<div className="listing__loader">
									<Loader />
								</div>
							)}
						</div>
					);
				}}
			/>
		);
	}
}

ListingContainer.propTypes = {
	route: PropTypes.object,
	history: PropTypes.shape({
		push: PropTypes.func,
		replace: PropTypes.func,
		location: PropTypes.object,
	}),
	fetchProducts: PropTypes.func,
	clearProduct: PropTypes.func,
	acceptCookyPolicy: PropTypes.func,
	products: PropTypes.arrayOf(productShape),
	productsFilterMetaData: PropTypes.object,
	resetAllProductsFilter: PropTypes.func,
	setProductsFilter: PropTypes.func,
	setProductsFilters: PropTypes.func,
	fetchNavLogs: PropTypes.func,
	productsFilters: PropTypes.object,
	match: PropTypes.object,
	authToken: PropTypes.string,
	resolution: PropTypes.string,
	shouldFetchNavlogs: PropTypes.bool,
	productsVisibility: PropTypes.string,
	shop: PropTypes.string,
	partnerCode: PropTypes.string,
};

const mapStateToProps = state => {
	return {
		prefetchedPhotos: getPrefetchedPhotos(state),
		brand: state.brand.code,
		shop: getCurrentShop(state),
		partnerCode: getPartnerCode(state),
		productsVisibility: state.productsVisibility,
		productsFilterMetaData: state.productsFilterMetaData,
		productsFilters: state.productsFilters,
		authToken: state.auth.token,
		resolution: state.resolution,
		marketing: getPartnerMarketing(state),
		shouldFetchNavlogs: shouldFetchNavlogs(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			fetchProducts,
			clearProduct,
			acceptCookyPolicy,
			resetAllProductsFilter,
			setProductsFilter,
			setProductsFilters,
			fetchNavLogs,
		},
		dispatch
	);
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(ListingContainer));
